module.exports = __webpack_public_path__ + "static/media/filter-results.e292611d.svg";